import { getReferer } from '@/common/utils/referer'
import _ from 'lodash'
import { loginProc } from '@/common/utils/login'
import {
  getPromotionCodeFromUrl,
  loginRedirectUrl,
  addQueryParams,
} from '@/common/utils/common'
import {
  PATH_NAME_ADULT_CONTENTS,
  PATH_NAME_LOGIN,
  PATH_NAME_LOGIN_APPLE,
} from '@/common/resources/router.const'
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'

export default [
  {
    path: 'member/login',
    name: PATH_NAME_LOGIN,
    meta: { menuIndex: 0 },
    alias: '/member/login.html',
    components: {
      bodyContent: () =>
        import(/* webpackChunkName: "login" */ '@/pages/member/login'),
    },
  },
  {
    path: 'member/login_apple',
    name: PATH_NAME_LOGIN_APPLE,
    alias: '/member/login_apple.html',
    beforeEnter: (to, from, next) => {
      const referer = getReferer()
      const returnUrl = cookie.getItem('w-apple-login-return-url')
      const token = _.get(to, 'query.id_token', '')
      if (returnUrl) {
        cookie.removeItem(
          'w-apple-login-return-url',
          constant.URL_COOKIE_DOMAIN,
          '/',
        )
        location.replace(
          addQueryParams(returnUrl, { token: token, type: 'apple' }),
        )
        return
      }
      // 애플 로그인 과정
      // 로그인 UI의 애플 로그인 버튼 클릭 -> 애플 로그인 화면으로 이동 -> 애플로그인 완료되면 login_apple.html로 redirect됨
      // 이때 로그인 성공 결과인 id_token을 query string으로 전달받음
      // 기존 로그인 화면, 로그인 팝업에서 애플 로그인 처리 로직을 이곳에서 관리하던 것을 유지
      loginProc({
        userType: 'apple',
        userId: token,
        userPassword: '',
        saveId: '',
        autoLogin: '',
      })
        .then((data) => {
          if (_.get(data, 'needselectprofile', 'n') === 'y') {
            next(
              '/member/profile_list.html?referer=' +
                encodeURIComponent(referer),
            )
          } else {
            if (referer !== '') {
              next(referer)
            } else {
              next('/')
            }
          }
        })
        .catch((error) => {
          const response = _.get(error, 'response', {})
          if (
            _.get(response, 'status', '') === 551 &&
            _.get(response, 'data.resultcode', '') === '302'
          ) {
            const redirectUrl = _.get(response, 'data.resultoptional', '')
            const referer = getReferer()
            location.href = loginRedirectUrl(
              redirectUrl,
              getPromotionCodeFromUrl(referer),
            )
          } else {
            alert('로그인 오류입니다.')
            next('/')
          }
        })
    },
  },
  {
    path: 'setting/adult',
    name: PATH_NAME_ADULT_CONTENTS,
    alias: 'setting/adult.html',
    components: {
      adult_contents: () => import('@/pages/settings/AdultContents'),
    },
  },
]
